<template>
  <b-card
    v-if="tableData"
    no-body
    class="card-company-table"
  >
    <b-table
      :items="tableData"
      responsive
      :fields="fields"
      class="mb-0"
    >
      <!-- company -->
      <template #cell(name)="data">
        <div class="d-flex align-items-center">
          <div>
            <div class="font-weight-bolder">
              {{ data.item.name }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(count)="data">
        <strong>{{ data.item.count ? data.item.count : "0" }}</strong>
      </template>
      <!-- revenue -->
      <template #cell(now)="data">
        <strong><small>SRD</small><br>{{ data.item.now ? kFormatter(data.item.now) : "0" }}</strong>
      </template>
      <template #cell(last)="data">
        <div
          v-if="data.item.last && data.item.now - data.item.last >= 0 && data.item.name!=='Royement'"
        >
          <strong style="color:#378805">{{ data.item.last ? ((data.item.now/data.item.last)*100).toFixed(2) : "0" }}%</strong>
        </div>
        <div
          v-if="data.item.last && data.item.now - data.item.last < 0 && data.item.name!=='Royement'"
        >
          <strong style="color:#FF0000">{{ data.item.last ? ((data.item.now/data.item.last)*100).toFixed(2) : "0" }}%</strong>
        </div>
        <div
          v-if="data.item.last && data.item.now - data.item.last > 0 && data.item.name==='Royement'"
        >
          <strong style="color:#FF0000">{{ data.item.last ? ((data.item.now/data.item.last)*100).toFixed(2) : "0" }}%</strong>
        </div>
        <div
          v-if="data.item.last && data.item.now - data.item.last <= 0 && data.item.name==='Royement'"
        >
          <strong style="color:#378805">{{ data.item.last ? ((data.item.now/data.item.last)*100).toFixed(2) : "0" }}%</strong>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BTable,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    pos: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      fields: [
        { key: 'name', label: '' },
        { key: 'count', label: 'Aantal' },
        { key: 'now', label: 'Deze maand' },
        { key: 'last', label: 't.o.v vorig jaar' },
      ],
    }
  },
  methods: {
    kFormatter,
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
